// extracted by mini-css-extract-plugin
export default {"get-discount":"CheckOut_get-discount__Ff0Ky"};